import { cn } from '../../utils/cn'
import type { SidebarIcon } from './model'
import { SIDEBAR_ROW } from './SidebarNavLink'
import { SidebarRowTooltip } from './SidebarRowTooltip'

interface SidebarSwitchRowProps {
  title: string
  icon: SidebarIcon
  onClick: () => void
}

/** A row that changes what the sidebar shows rather than navigating anywhere. */
export function SidebarSwitchRow({ title, icon: Icon, onClick }: SidebarSwitchRowProps) {
  return (
    <li className="relative">
      <SidebarRowTooltip label={title}>
        <button type="button" onClick={onClick} className={cn(SIDEBAR_ROW, 'cursor-pointer')}>
          <Icon aria-hidden="true" />
          <span>{title}</span>
        </button>
      </SidebarRowTooltip>
    </li>
  )
}
